import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../../assets/images/closeIconModal.svg";
import { useDispatch } from "react-redux";
import { updateExtendTime } from "live-slices/orders/thunk";
import axios from "axios";

const ExtendTimeModal = ({
  show,
  onCloseClick,
  // onConfirm,
  orderDetail,
}: any) => {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleTimeSelect = (time: any) => {
    setSelectedTime(time);
  };

  const dispatch: any = useDispatch();

  const onClickOrderTimingChange = async (
    orderId: string,
    orderAcceptTime?: any
  ) => {
    try {
      const response = await axios.put(
        `api/v1/order/extendedTime?orderId=${orderId}&time=${orderAcceptTime}`
      );
      if (response?.data) {
        setSubmitted(true);
        onCloseClick(false);
        window.location.reload();
      }
    } catch (err: any) {
    } finally {
    }
  };

  const handleSubmit = async () => {
    if (selectedTime) {
      await onClickOrderTimingChange(orderDetail._id, selectedTime);
    } else {
      setSubmitted(false);
    }
  };

  return (
    <Modal isOpen={show} centered={true} className="reasonModl">
      <ModalBody className="modal_Body">
      <img
            data-testing-id="closeIcon"
            onClick={() => onCloseClick(false)}
            className='closeIconModal'
            src={CLoseImg}
            alt=""
          />
        <div className="mainDv">
          <div className="flexDv">
            <h1>Extend Order Time</h1>
            {/* <a>
              <div className="dot"></div>
              Order {orderDetail?.status}
            </a> */}
          </div>
          <h6>Order Details (#{orderDetail?.buypassId})</h6>
          <p>Select how much time you need to extend this order.</p>
          <div className="radioDv">
            {[
              { name: "5 Min", value: 5 },
              { name: "15 Min", value: 15 },
              { name: "20 Min", value: 20 },
              { name: "25 Min", value: 25 },
            ].map((time) => (
              <div key={time.value} className="contDv">
                <Input
                  type="radio"
                  className="form-check-input rounded-circle mt-0 me-2"
                  value={time.value}
                  checked={selectedTime === time.value}
                  onChange={() => handleTimeSelect(time.value)}
                />
                <h6>{time.name}</h6>
              </div>
            ))}
          </div>
          <div className="btnDv">
            <button
              onClick={handleSubmit}
              disabled={!selectedTime || submitted}
            >
              {submitted ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ExtendTimeModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirm: PropTypes.func,
  show: PropTypes.bool,
  orderDetail: PropTypes.any,
};

export default ExtendTimeModal;
